<app-modal #selecionarAgenteModal [ignoreBackdropClick]="true" title="Selecione um Agente" labelClose="Cancelar" labelOk="Confirmar">
    <div class="agente-options">
        <div *ngFor="let ag of agentes">
            <input #radio type="radio" [value]="ag" [(ngModel)]="agente">
            <span (click)="radio.click()" class="agente-name cursor-pointer">{{ag.id}} - {{ag.nome}}</span>
        </div>
    </div>
</app-modal>